import { Container, Flex, Grid, Text, Box, Link, VStack, Stack, GridItem, Image as ChakraImage } from '@chakra-ui/react';
import { Breadcrumb, Button, ImageTileResult, FlightTile, DatesTile, LoadMoreImages, IconTile, Divider, Checkbox, DateRangeWithInput, Footer } from 'components';
import { IMAGE_TILE_URL } from 'data';
import { BsPeople, BsDoorClosed, BsSnow } from 'react-icons/bs';
import { TbTextResize } from 'react-icons/tb';
import { MdAttractions, MdOutlineEmojiPeople, MdOutlineKingBed, MdOutlineLocalLaundryService } from 'react-icons/md';
import { ChangeEvent, ReactNode } from 'react';
import { AiFillCar, AiOutlineWifi } from 'react-icons/ai';
import { IoAirplaneOutline, IoPaw, IoTvSharp } from 'react-icons/io5';

import { activities } from 'data';
import { useHistory } from 'react-router-dom';

const linkList = [
  { link: '/', title: 'Search ' },
  { link: '/', title: 'Trip pack' },
  { link: '/', title: 'Kolombo&Spa' },
];
const SpaceBetweenFlexContainer = ({ children }: { children: ReactNode | ReactNode[]; }) => (
  <Flex justifyContent='space-between' alignItems='center' gap={[4]} >
    {children}
  </Flex>
);

const TripPackResult = () => {
  const onClickTicketDetails = () => { };
  const onIconTileClick = () => { };
  const history = useHistory();
  // @ts-ignore
  const show =  typeof history.location.state?.showActivities === 'boolean' ? history.location.state?.showActivities : true;

  return (
    <>
      <Container maxW='container.xl'>
        <VStack gap={[3, 5]}>
          <Breadcrumb linkList={linkList} />
          <ImageTileResult
            bgImage={IMAGE_TILE_URL.sigiriya}
            title='Kolombo & Spa'
            type='Trip package'
            highlights='Flight + Stay + Activities'
          />
        </VStack>
      </Container>
      {show && <><Container maxW='container.xl'>
        <Flex justifyContent='space-between' alignItems='center'
          paddingY={[3, 5, 8]}>
          <Text fontSize={[14, 18]} fontWeight={700} flexWrap={'nowrap'}>
            Flight details
          </Text>
          <Flex gap={[2, 2, 4]}>
            <Button onClick={onClickTicketDetails} label='Ticket Details'
              size={['sm', 'md']} colorScheme='blue' />
            <Button onClick={onClickTicketDetails} label='Modify'
              size={['sm', 'md']} colorScheme='blue' />
          </Flex>
        </Flex>
      </Container><Container maxW='container.xl' h={'100%'}
        paddingBottom={[3]}>
          <Flex justifyContent='space-between'
            direction={['column', 'column', 'column', 'column', 'row']}
            gap={[1, 2, 3, 5]}>
            <DatesTile dates={{ start: new Date(), end: new Date() }} />
            <Flex
              flex='0 1 100%'
              direction={['column', 'row']}
              gap={[1, 2, 3, 5]}>
              <FlightTile label='Departure' details={{ departure: 'NYC', arrival: 'CMB' }} />
              <FlightTile label='Return' details={{ departure: 'CMB', arrival: 'NYC' }} />
            </Flex>
          </Flex>
        </Container></>}
      <Container maxW='container.xl' marginTop={show ? 0 : 4 }>
        <LoadMoreImages
          title='Kolombo & Spa'
          subtitle='Your hotel'
          images={[
            { url: 'https://images.unsplash.com/photo-1612862862126-865765df2ded?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NXx8c3JpJTIwbGFua2F8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1582103517762-613cc237349b?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mzh8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1544015759-237f87d55ef3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8c3JpJTIwbGFua2F8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1552055568-e9943cd2a08f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MjB8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1583653319049-4db347571740?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Mjl8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1574611122955-5baa61496637?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NHx8c3JpJTIwbGFua2F8ZW58MHx8MHx8&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1509763877072-959eda51e6d6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NTZ8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1606512180004-f1ec207ad076?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8NzV8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
            { url: 'https://images.unsplash.com/photo-1619714604882-db1396d4a718?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxzZWFyY2h8ODB8fHNyaSUyMGxhbmthfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=800&q=60' },
          ]}
        />
      </Container>

      <Container maxW='container.xl'>
        <Flex paddingY={[2, 3, 5]}>
          <Text fontSize='26px' fontWeight={700}>
            Details
          </Text>
        </Flex>

        <Flex justifyContent='space-between'
          direction={['column', 'column', 'column', 'row']}
          gap={[2, 4, 6]}
        >

          <Stack gap={[1, 2, 3]} flex={'0 2 100%'}>
            <Box width={['100%']} >
              <Flex flexWrap={'wrap'} gap={[2, 4]}>
                <IconTile onIconTileClick={onIconTileClick} title='2 Adults' icon={<BsPeople />} iconDirection='column' />
                <IconTile onIconTileClick={onIconTileClick} title='500 sq m' icon={<TbTextResize />} iconDirection='column' />
                <IconTile onIconTileClick={onIconTileClick} title='1 Bedroom' icon={<BsDoorClosed />} iconDirection='column' />
                <IconTile
                  onIconTileClick={onIconTileClick}
                  title='1 Queen Bed'
                  icon={<MdOutlineKingBed />}
                  iconDirection='column'
                />
              </Flex>

              <Text>
                Designed over 500 square meters, the rooms consists of a queen sized bed and ensuite a bathroom. The spaces are
                fitted with working stations. Designed with intention in communion wuth the vibrant neighbourhood, the rooms
                accommodate up tp two people. Room is fitted with a balcony. At Kolombo & Spa the room include air conditioning
                and a flat-screen TV. Guests at the accommodation can enjoy a continental or a buffet breakfast.
              </Text>
              <Flex marginTop='50px'>
                <Text fontSize='26px' fontWeight={700}>
                  Room Amenities
                </Text>
              </Flex>
              <Flex flexWrap={'wrap'} gap={[2, 4]}>
                <IconTile onIconTileClick={onIconTileClick} title='Everyday Laundry' icon={<MdOutlineLocalLaundryService />} iconDirection='row' />
                <IconTile onIconTileClick={onIconTileClick} title='Airport Shuttle' icon={<AiFillCar />} iconDirection='row' />
                <IconTile onIconTileClick={onIconTileClick} title='Free WiFi' icon={<AiOutlineWifi />} iconDirection='row' />
                <IconTile
                  onIconTileClick={onIconTileClick}
                  title='Central Aircon'
                  icon={<BsSnow />}
                  iconDirection='row'
                />
                <IconTile onIconTileClick={onIconTileClick} title='Flat Screen Television' icon={<IoTvSharp />} iconDirection='row' />
                <IconTile onIconTileClick={onIconTileClick} title='Pets Allowed' icon={<IoPaw />} iconDirection='row' />
              </Flex>

            </Box>

            <Box borderRadius='50px'
              border='1px'>
              <Flex padding={[10, 20, 30]} flexDirection='column'
                gap={[1, 2, 3]} justifyContent='space-evenly'>
                <SpaceBetweenFlexContainer>
                  <Text fontWeight={500} fontSize="16px">Check-in Time</Text>
                  <Text fontWeight={500} fontSize="16px" textAlign='end'>Check-out Time</Text>
                </SpaceBetweenFlexContainer>
                <SpaceBetweenFlexContainer>
                  <Text fontWeight={700} fontSize="18px">1 PM</Text>
                  <Text fontWeight={700} fontSize="18px" textAlign='end'>11 AM</Text>
                </SpaceBetweenFlexContainer>
                <SpaceBetweenFlexContainer>
                  <Text fontWeight={400} color="#6F6F6F" fontSize="12px">Early Check-in Upon Request</Text>
                  <Text fontWeight={400} color="#6F6F6F" fontSize="12px" textAlign='end'>Early Check-in Upon Request</Text>
                </SpaceBetweenFlexContainer>
              </Flex>
            </Box>
          </Stack>

          <Stack gap={[1, 2, 3]} flex={'0 2 100%'}>
            <Box borderRadius='50px'
              borderWidth='1px'
              width='100%' padding='20px' borderStyle='solid'
            >
              <Flex flexDirection='row'
                alignItems='center' >
                <Text fontSize='32px' fontWeight={700}>$90</Text>
                <Text fontSize='26px' color='#A3A3A3' fontWeight={700}> / night </Text>
              </Flex>

              <Divider />

              <Box marginY={5}>
                <DateRangeWithInput onChange={() => { }} placeholder={''} tabChanged={false} />
              </Box>

              <Container paddingX={['4%', '8%', '10%', '12%']}
                marginY={['4%', '6%', '8%', '10%']} gap={[2]}>
                <Text color='#1F1E1E' fontWeight={600} fontSize="16px" marginTop='10px'>
                  17 nights
                </Text>
                <Divider />
                <Text color='#1F1E1E' fontWeight={500} fontSize="16px" marginTop='10px' marginBottom="10%">
                  Add extras
                </Text>
                <Flex flexDirection='column' gap={[2]}>

                  <SpaceBetweenFlexContainer>
                    <Checkbox size="lg" label="Breakfast per day per person" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                      throw new Error("Function not implemented.");
                    }} />
                    <Text fontWeight={500} fontSize="16px">$3</Text>
                  </SpaceBetweenFlexContainer>

                  <SpaceBetweenFlexContainer>
                    <Checkbox size="lg" label="Parking a day" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                      throw new Error("Function not implemented.");
                    }} />
                    <Text fontWeight={500} fontSize="16px">$1</Text>
                  </SpaceBetweenFlexContainer>

                  <SpaceBetweenFlexContainer>
                    <Checkbox size="lg" label="Iron & Iron Board" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                      throw new Error("Function not implemented.");
                    }} />
                    <Text fontWeight={500} fontSize="16px">Free</Text>
                  </SpaceBetweenFlexContainer>

                  <SpaceBetweenFlexContainer>
                    <Checkbox size="lg" label="Baby Crib" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                      throw new Error("Function not implemented.");
                    }} />
                    <Text fontWeight={500} fontSize="16px">Free</Text>
                  </SpaceBetweenFlexContainer>

                  <SpaceBetweenFlexContainer>
                    <Checkbox size="lg" label="Pet Food a day" onChange={function (event: ChangeEvent<HTMLInputElement>): void {
                      throw new Error("Function not implemented.");
                    }} />
                    <Text fontWeight={500} fontSize="16px">$2</Text>
                  </SpaceBetweenFlexContainer>

                </Flex>
                <Divider />

                <Flex paddingY={[4]}>
                  <SpaceBetweenFlexContainer >
                    <Flex padding={0} align='center' gap={[2]}>
                      <Text fontWeight={600} fontSize="16px">Total</Text>
                      <Text color='#A3A3A3' fontWeight={400} fontSize="12px">(including all taxes)</Text>
                    </Flex>
                    <Text fontWeight={600} fontSize="16px">$2.250</Text>
                  </SpaceBetweenFlexContainer>
                </Flex>

                <Button label='Book now full package'
                  minWidth='100%'
                  size='lg' onClick={() => { }} colorScheme='blue' />
              </Container>
            </Box>

            <Box borderRadius='50px'
              backgroundColor='#FBFBFB'
              boxShadow=' 0px 20px 25px -5px rgba(151, 151, 151, 0.1), 0px 10px 10px -5px rgba(151, 151, 151, 0.04)'>
              <Flex
                padding='50px'
                width={['100%']}
                flexDirection='column' justifyContent='space-between'>
                <Text marginBottom='10px' fontWeight={700} fontSize='16px'>Promotion!</Text>
                <Text marginBottom='10px' fontWeight={400} fontSize='17px'>With only $20 extra you can enjoy a room with access to balcony!</Text>
                <Link alignSelf='end' color='#3498FE' fontWeight={500} fontSize='16px'>Check Offer</Link>
              </Flex>
            </Box>
          </Stack>

        </Flex>

      {show ? <VStack marginTop='50px' alignItems={'flex-start'}>
          <Text fontSize='26px' fontWeight={700}>
            Activities
          </Text>

          <Grid
            width='100%'
            height='100%'
            templateRows='repeat(auto, 1fr)'
            templateColumns={[
              'repeat(1, auto)',
              'repeat(2, 1fr)',
            ]}
            gap={4}>

            {activities.map((activity) => (
              <GridItem
                rowSpan={1}
                colSpan={1}
                width='100%'
                height='100%'
                maxHeight={[150]}
              >
                <ChakraImage borderRadius='25px'
                  objectFit='cover'
                  width='100%'
                  height='100%'
                  src={activity.imageSrc}
                  alt='Image of location'
                />

                <Flex
                  width='100%'
                  height='100%'
                >
                  <Box
                    display='flex'
                    justifyContent='center'
                    flexDirection='column'
                    backgroundColor='rgba(18, 17, 17, 0.6)'
                    width='100%'
                    height={150}
                    position='relative'
                    bottom={'100%'}
                    zIndex={3}
                    borderRadius='25px'
                  >
                    <Text alignSelf='center' cursor='pointer' fontSize={[18, 24, 32]} color='white'>
                      {activity.label}
                    </Text>
                  </Box>
                </Flex>

              </GridItem>
            ))}

          </Grid>

        </VStack> : <></>
        }

        <Text fontSize='26px' marginTop='50px' fontWeight={700} marginBottom='20px'>
          Property Surroundings
        </Text>

        <Flex justifyContent='space-between' gap={[2, 3, 4]}
          direction={['column', 'column', 'column', 'row']}
        >
          <Flex flexDirection='column' >
            <Flex marginBottom='5px'>
              <MdOutlineEmojiPeople size='30px' />
              <Text marginBottom='5px' marginLeft='16px' fontWeight={600} fontSize='20px'>What’s nearby</Text>
            </Flex>
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Imperial Mall</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.2 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>F9 Public Park</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.6 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Colombo Monument</Text>
              <Text fontWeight={400} fontSize='17px'>0.7 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Village</Text>
              <Text fontWeight={400} fontSize='17px'>1 km</Text>
            </SpaceBetweenFlexContainer >
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Market</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.8 km</Text>
            </SpaceBetweenFlexContainer >
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Downtown</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.1 km</Text>
            </SpaceBetweenFlexContainer >
            <Divider />
          </Flex>

          <Flex flexDirection='column' >
            <Text marginBottom='5px' fontWeight={600} fontSize='20px'>Restaurant & Cafe</Text>
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Restaurant - Kolameats</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.2 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Cafe - Starbucks</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.6 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <Flex>
              <MdAttractions size='30px' />
              <Text marginLeft='16px' marginBottom='5px' fontWeight={600} fontSize='20px'>Attractions</Text>
            </Flex>
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Restaurant - Kolameats</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.2 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Cafe - Starbucks</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.6 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
          </Flex>

          <Flex flexDirection='column' >
            <Text marginBottom='5px' fontWeight={600} fontSize='20px'>Natural Beauty</Text>
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Colombo Lake</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.2 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Colombo Hills</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.6 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
            <Flex>
              <IoAirplaneOutline size='30px' />
              <Text marginBottom='5px' marginLeft='16px' fontWeight={600} fontSize='20px'>Airport</Text>
            </Flex>
            <SpaceBetweenFlexContainer>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>Colombo International</Text>
              <Text marginBottom='5px' fontWeight={400} fontSize='17px'>0.2 km</Text>
            </SpaceBetweenFlexContainer>
            <Divider />
          </Flex>

        </Flex >

      </Container>
      <Footer />
    </>
  );
};

export { TripPackResult };
